import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import NoirDispatchers from './NoirDispatchers';
import NoirSimulator from './NoirSimulator';
import NoirBroadcast from './NoirBroadcast';
import NoirLeaderboard from './NoirLeaderboard';
import NoirConversations from './NoirConversations';
import NoirRedeemableCodes from './NoirRedeemableCodes';
import NoirWaitlist from './NoirWaitlist';
import { getConciergeCuratorApplications } from '../../api/noir';
import './Noir.scss';

const TABS = [
  { value: 'dispatchers', display: 'Dispatchers' },
  { value: 'conversations', display: 'Conversations' },
  { value: 'simulator', display: 'Simulate' },
  { value: 'broadcast', display: 'Broadcast' },
  { value: 'leaderboard', display: 'Editor Leaderboard' },
  { value: 'codes', display: 'Redeemable Codes' },
  { value: 'waitlist', display: 'Curator Waitlist' }
];

const Noir = () => {
  const history = useHistory();
  const location = useLocation();
  const [pendingApplicationCount, setPendingApplicationCount] = useState(0);

  useEffect(() => {
    getConciergeCuratorApplications({ status: 'pending' })
      .then(resp => setPendingApplicationCount(Array.isArray(resp) ? resp.length : 0))
      .catch(() => {});
  }, []);

  const params = new URLSearchParams(location.search);
  const activeTab = TABS.find(t => t.value === params.get('tab'))?.value || 'dispatchers';

  const setActiveTab = tab => {
    const next = new URLSearchParams(location.search);
    next.set('tab', tab);
    history.push({ search: next.toString() });
  };

  return (
    <div className='noir-outer'>
      <div className='noir-header'>
        <h1 className='noir-title'>Noir Concierge</h1>
        <div className='noir-tabs'>
          {TABS.map(tab => (
            <div key={tab.value} className={cn('noir-tab', { active: activeTab === tab.value })} onClick={() => setActiveTab(tab.value)}>
              {tab.display}
              {tab.value === 'waitlist' && pendingApplicationCount > 0 && <span className='tab-badge'>{pendingApplicationCount}</span>}
            </div>
          ))}
        </div>
      </div>
      <div className='noir-content'>
        {activeTab === 'dispatchers' && <NoirDispatchers />}
        {activeTab === 'conversations' && <NoirConversations />}
        {activeTab === 'simulator' && <NoirSimulator />}
        {activeTab === 'broadcast' && <NoirBroadcast />}
        {activeTab === 'leaderboard' && <NoirLeaderboard />}
        {activeTab === 'codes' && <NoirRedeemableCodes />}
        {activeTab === 'waitlist' && <NoirWaitlist />}
      </div>
    </div>
  );
};

export default Noir;
